import { render, staticRenderFns } from "./ProductEditRemark.vue?vue&type=template&id=0c0d1ece&"
import script from "./ProductEditRemark.vue?vue&type=script&lang=js&"
export * from "./ProductEditRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports